import { useRef, useState } from 'react';

// Tracks cursor position relative to a section so a decorative glow can
// follow the mouse. Attach `ref`/`onMouseMove`/`onMouseEnter`/`onMouseLeave`
// to the section element, then render <SpotlightGlow pos={pos} active={active} />.
export function useSpotlight() {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [active, setActive] = useState(false);

  const onMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return {
    ref,
    pos,
    active,
    onMouseMove,
    onMouseEnter: () => setActive(true),
    onMouseLeave: () => setActive(false),
  };
}
